import * as React from 'react';

import {
  LoadingContainer,
  LoadingProgressContainer,
  LoadingProgress,
  LoadingContentContainer,
  CSSSpinner,
  VisuallyHidden,
} from './LoadingComponent.style';
import {messages} from '../../utils';

type LoadingProps = {
  loading?: boolean;
  progress?: number;
  customMessage?: string;
};

/**
 * LoadingComponent
 * Displays a loading indicator with optional progress bar
 *
 * Migration Notes:
 * - Previously used WorkoutRoutineContext for loading/progress state
 * - Now accepts loading and progress as props directly
 * - Requirements: 7.3 - Remove legacy context dependencies
 */
const LoadingComponent = ({
  loading = false,
  progress = 0,
  customMessage,
}: LoadingProps): JSX.Element => {
  return (
    <LoadingContainer loading={(loading || '').toString()}>
      {customMessage ? customMessage : messages.server.loading}
      <LoadingProgressContainer>
        <LoadingProgress progress={progress} />
      </LoadingProgressContainer>
    </LoadingContainer>
  );
};

export const LoadingContent = ({loading}: {loading?: boolean}): JSX.Element => {
  return (
    <LoadingContentContainer role="status" aria-live="polite">
      <VisuallyHidden>Loading</VisuallyHidden>
      <CSSSpinner aria-hidden="true" />
    </LoadingContentContainer>
  );
};

export {LoadingComponent};
